<template>
  <div id="home">
      <br>
      <h1><strong>ROCK RECORDS</strong></h1>
      <br>
   <CarouselRock/>
   <br>
   <DiscograficasRock/>
</div>
</template>

<script>
import CarouselRock from '../components/CarouselRock';
import DiscograficasRock from '../views/DiscograficasRock.vue';

export default {
 name: 'HomeRock',
 components: {
  CarouselRock,
  DiscograficasRock
}
}
</script>